import React, { useEffect } from "react";
import SingleChatRoom from "./SingleChatRoom";

const PendingChatRoom = (props) => {
  const {
    isLoading,
    type,
    data,
    setState,
    state,
    showSingleChat,
    getChats,
    status,
    success,
    sortSuccess,
    openModal,
    filterChatRooms,
    filterSuccess
  } = props;

  useEffect(
    () => {
      if (
        filterSuccess
      
      ) {
        return filterChatRooms(
          status,
          state.filterValues.created_from,
          state.filterValues.created_to
        );
      }
      getChats(status);
    },
    // eslint-disable-next-line
    [filterSuccess]
  );

  return (
    <SingleChatRoom
      isLoading={isLoading}
      data={data}
      setState={setState}
      state={state}
      showSingleChat={showSingleChat}
      success={success}
      sortSuccess={sortSuccess}
      status={status}
      openModal={openModal}
      type={type}
    />
  );
};

export default PendingChatRoom;
